import React from 'react';

export function GlyphIcon({icon}) {
  return <span className={"glyphicon glyphicon-"+icon} aria-hidden="true" />;
}

export default GlyphIcon;



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/bootstrap/GlyphIcon.jsx